

import React from 'react';
import ZNetwork from "./znetwork";
import ZUtil from "./zutil.js";

export default class ZooUserAnnualActivity extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let { user_uri } = this.props;
		let year = new Date().getFullYear();
//		ZNetwork.post("useractivity", { user_uri: user_uri, year: year }, (err, activity) => {
		ZNetwork.get(["user", "activity", user_uri, year], (err, activity) => {
			if (err || !activity) {
				return this.setState({ error: "No activity found for user" });
			}
			let doy = 0;
			let html = [
				`<svg width="722" height="112" class="ZooUserActivityChart">
					<g transform="translate(14, 20)">
				`
			];
			let date = ZUtil.getDateFromDayOfYear(0, year);	
			let start_dow = date.getDay();
			this._getBusyColor = (count) => {
				count = count || 0;
				let MAXCOUNT = 150;
				count = Math.min(1, count / MAXCOUNT);
				// more color variation at lower counts
				count = 1 - Math.cos(Math.PI/2 * count);
				count = Math.max(count === 0 ? 0 : 1, Math.floor(count * 10));
				return [
					"#eee", 
					"#acd",
					"#9cd",
					"#9bd",
					"#9ac",
					"#8ac",
					"#7ac",
					"#6ac",
					"#59c",
					"#48c",
					"#37c",
					"#26c",
				][count];
				// return `rgba(0,100,0, ${(Math.max(count, 100) /100) + 0.1}`;
			};
			const date_options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
			for (let week = 0; week < 53; ++ week) {
				html.push(`<g transform="translate(${week*13}, 0)">`);
				let dow = 0;
				if (week === 0) {
					while (dow++ < start_dow) {
						date = ZUtil.getDateFromDayOfYear(dow, year);	
          					html.push(`<rect class="Day" width="10" height="10" x="14" y="${dow * 13}" fill="#ffffff" data-count="0" data-date="${ZUtil.toShortDate(date)}"/>`);
					}
				}
				for (; dow < 7; ++dow) {
					date = ZUtil.getDateFromDayOfYear(doy + 1, year);
					let acts = activity["day" + doy];
          				html.push(`<rect class="Day ZToolTip ZToolTipTop" width="10" height="10" x="14" y="${dow * 13}" fill="${this._getBusyColor(acts)}" data-tooltip="${acts ? acts + ' actions' : 'No activity'} on ${date.toLocaleDateString(undefined, date_options)}" />`);
					doy += 1;
					if (doy > 365) {
						break;
					}
				}
				html.push("</g>");
			}
			html.push( `
				<text x="27" y="-7" class="month">Jan</text>
				<text x="79" y="-7" class="month">Feb</text>
				<text x="131" y="-7" class="month">Mar</text>
				<text x="196" y="-7" class="month">Apr</text>
				<text x="248" y="-7" class="month">May</text>
				<text x="300" y="-7" class="month">Jun</text>
				<text x="365" y="-7" class="month">Jul</text>
				<text x="417" y="-7" class="month">Aug</text>
				<text x="469" y="-7" class="month">Sep</text>
				<text x="534" y="-7" class="month">Oct</text>
				<text x="586" y="-7" class="month">Nov</text>
				<text x="638" y="-7" class="month">Dec</text>
				<text text-anchor="start" class="wday" dx="-14" dy="8" style="display: none;">Sun</text>
				<text text-anchor="start" class="wday" dx="-14" dy="22">Mon</text>
				<text text-anchor="start" class="wday" dx="-14" dy="32" style="display: none;">Tue</text>
				<text text-anchor="start" class="wday" dx="-14" dy="48">Wed</text>
				<text text-anchor="start" class="wday" dx="-14" dy="57" style="display: none;">Thu</text>
				<text text-anchor="start" class="wday" dx="-14" dy="73">Fri</text>
				<text text-anchor="start" class="wday" dx="-14" dy="81" style="display: none;">Sat</text>
				</g></svg>
			`);
			this.setState({ html: html.join("\n") });
		});
	}
/*
	onMouseOver = (e) => {
		let days = e.target.getElementsByClassName("Day");
		let day = ZUtil.pick(days, e.
		if (day) {
*/
			
	render() {
		let { html } = this.state;
		if (!html) {
			return null;
		}
		return	(
			<div className="AMCUserAnnualActivity" dangerouslySetInnerHTML={{ __html: html }}>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/ZooUserAnnualActivity.js